/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "标记模板字面量(Tagged Template Literals)"
    }), "\n", _jsx(_components.p, {
      children: "¥Tagged Template Literals"
    }), "\n", _jsx(_components.p, {
      children: "标记模板字面量是 ES6 中的一项新功能。它们允许你定义自定义字符串插值规则，这就是我们创建样式组件的方式。"
    }), "\n", _jsx(_components.p, {
      children: "¥Tagged Template Literals are a new feature in ES6. They let you define custom string interpolation rules,\nwhich is how we're able to create styled components."
    }), "\n", _jsx(_components.p, {
      children: "如果不传递插值，则函数接收的第一个参数是一个包含字符串的数组。"
    }), "\n", _jsx(_components.p, {
      children: "¥If you pass no interpolations, the first argument your function receives is an array with a string in it."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "// These are equivalent:\nfn`some string here`;\nfn(['some string here']);\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "传递插值后，数组将包含传递的字符串，并在插值的位置处拆分。其余参数将按顺序进行插值。"
    }), "\n", _jsx(_components.p, {
      children: "¥Once you pass interpolations, the array contains the passed string, split at the positions of the interpolations.\nThe rest of the arguments will be the interpolations, in order."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const aVar = 'good';\n\n// These are equivalent:\nfn`this is a ${aVar} day`;\nfn(['this is a ', ' day'], aVar);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这使用起来有点麻烦，但这意味着我们可以在样式组件中接收变量、函数或 mixin（", _jsx(_components.code, {
        children: "css"
      }), " 助手），并且可以将其扁平化为纯 CSS。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is a bit cumbersome to work with, but it means that we can receive variables, functions, or mixins\n(", _jsx(_components.code, {
        children: "css"
      }), " helper) in styled components and can flatten that into pure CSS."]
    }), "\n", _jsxs(_components.p, {
      children: ["说到这里，在展平期间，styled-components 会忽略计算结果为 ", _jsx(_components.code, {
        children: "undefined"
      }), "、", _jsx(_components.code, {
        children: "null"
      }), "、", _jsx(_components.code, {
        children: "false"
      }), " 或空字符串 (", _jsx(_components.code, {
        children: "\"\""
      }), ") 的插值，这意味着你可以自由使用 ", _jsx(_components.a, {
        href: "https://web.nodejs.cn/en-US/docs/Web/JavaScript/Reference/Operators/Logical_AND#Short-circuit_evaluation",
        children: "短路评估"
      }), " 有条件地添加 CSS 规则。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Speaking of which, during flattening, styled-components ignores interpolations that evaluate to ", _jsx(_components.code, {
        children: "undefined"
      }), ", ", _jsx(_components.code, {
        children: "null"
      }), ",\n", _jsx(_components.code, {
        children: "false"
      }), ", or an empty string (", _jsx(_components.code, {
        children: "\"\""
      }), "), which means you're free to use\n", _jsx(_components.a, {
        href: "https://web.nodejs.cn/en-US/docs/Web/JavaScript/Reference/Operators/Logical_AND#Short-circuit_evaluation",
        children: "short-circuit evaluation"
      }), "\nto conditionally add CSS rules."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Title = styled.h1<{ $upsideDown?: boolean; }>`\n  /* Text centering won't break if props.$upsideDown is falsy */\n  ${props => props.$upsideDown && 'transform: rotate(180deg);'}\n  text-align: center;\n`;\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果你想了解有关标记模板字面量的更多信息，请查看 Max Stoiber 的文章：", _jsx(_components.a, {
        href: "https://mxstbr.blog/2016/11/styled-components-magic-explained/",
        children: "💅🏾 styled-components 背后的魔力"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you want to learn more about tagged template literals, check out Max Stoiber's article:\n", _jsx(_components.a, {
        href: "https://mxstbr.blog/2016/11/styled-components-magic-explained/",
        children: "The magic behind 💅🏾 styled-components"
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
